export enum Email {
  Contact1 = 'renaissance@renaissancecapital.com',
  Contact2 = 'diobbi@renaissancecapital.com',
  Contact3 = 'pvarani@renaissancecapital.com',
}
